// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { list, $delete, createOrUpdate, get } from "./operations.js";
export type {
  TrustedAccessRoleBindingsListOptionalParams,
  TrustedAccessRoleBindingsDeleteOptionalParams,
  TrustedAccessRoleBindingsCreateOrUpdateOptionalParams,
  TrustedAccessRoleBindingsGetOptionalParams,
} from "./options.js";
